module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/gsZTeX/tc-custom/9783985312061.jpg?1702957028663",
      "alt": "This image is the cover for the book A Witch of the Hills Vol 1 and 2 Complete, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Witch of the Hills Vol 1 and 2 Complete, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Excerpt: Poor little witch! I think she left all her spells and love-philters behind her, when she let herself be carried off from Ballater to Bayswater, a spot where no sorcery more poetical or more interesting than modern Spiritualism finds a congenial home. What was her star about not to teach her that human hearts can beat as passionately up among the quiet hills and the dark fir-forests as down amid the rattle and the roar of the town? Well, well; it is only in the grave[2] that we make no mistakes; and life and love, God knows, are mysteries beyond the ken of a chuckle-headed country gentleman, with just sense enough to handle a gun and land a salmon.\"")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Florence Warden\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Florence Warden (16 May 1857 – 11 May 1929) was an English actress and writer, who wrote many novels under her stage name, her name at birth being Florence Alice Price and her married name Mrs G. E. James.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0